import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) {
  var r = _isNativeReflectConstruct();
  return function () {
    var e,
      o = _getPrototypeOf(t);
    if (r) {
      var s = _getPrototypeOf(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
import React from 'react';
import { Grid } from 'semantic-ui-react';
import SearchLocations from './components/SearchLocations';
import GeoClosestLocation from '../../darkmatter/GeoClosestLocation';
import Location from '../../molecules/Location';
import { LocationPropType } from '../../services/proptypes';
import './LocationsSorted.css';
var LocationsSorted = /*#__PURE__*/function (_React$Component) {
  _inherits(LocationsSorted, _React$Component);
  var _super = _createSuper(LocationsSorted);
  function LocationsSorted(props) {
    var _this;
    _classCallCheck(this, LocationsSorted);
    _this = _super.call(this, props);
    _this.state = {
      searchQuery: '',
      startOrderByDistance: false
    };
    _this.applyFilter = _this.applyFilter.bind(_assertThisInitialized(_this));
    _this.onStartSortByDistance = _this.onStartSortByDistance.bind(_assertThisInitialized(_this));
    _this.onSearchChange = _this.onSearchChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(LocationsSorted, [{
    key: "onStartSortByDistance",
    value: function onStartSortByDistance() {
      this.setState({
        startOrderByDistance: true
      });
    }
  }, {
    key: "onSearchChange",
    value: function onSearchChange(e) {
      this.setState({
        searchQuery: e.target.value
      });
    }
  }, {
    key: "applyFilter",
    value: function applyFilter() {
      var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var searchQuery = this.state.searchQuery;
      var filteredLocations = locations;
      if (searchQuery && searchQuery.length) {
        var re = new RegExp(searchQuery, 'i');
        filteredLocations = locations.filter(function (loc) {
          var keys = Object.keys(loc);
          for (var i = 0; i < keys.length; i += 1) {
            var key = keys[i];
            if (key !== 'id' && _typeof(loc[key]) !== 'object' && re.test(loc[key])) {
              return true;
            }
          }
          return false;
        });
      }
      return filteredLocations;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        locations = _this$props.locations,
        searchHeader = _this$props.searchHeader,
        searchHeaderAs = _this$props.searchHeaderAs,
        searchPlaceholder = _this$props.searchPlaceholder,
        verticalAlign = _this$props.verticalAlign,
        horizontalAlign = _this$props.horizontalAlign,
        className = _this$props.className,
        showIcon = _this$props.showIcon,
        distanceUnit = _this$props.distanceUnit;
      var _this$state = this.state,
        searchQuery = _this$state.searchQuery,
        startOrderByDistance = _this$state.startOrderByDistance;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GeoClosestLocation, {
        start: startOrderByDistance,
        locations: locations,
        distanceUnit: distanceUnit
      }, function (_ref) {
        var loading = _ref.loading,
          geoClosestLocations = _ref.locations,
          geoClosestLocationStatus = _ref.state;
        var filteredLocations = _this2.applyFilter(geoClosestLocations);
        var noResults = filteredLocations.length === 0;
        return /*#__PURE__*/React.createElement(Grid, {
          id: "location-grid",
          stackable: true,
          className: className,
          verticalAlign: verticalAlign,
          textAlign: horizontalAlign
        }, /*#__PURE__*/React.createElement(Grid.Row, null, /*#__PURE__*/React.createElement(Grid.Column, {
          width: 16
        }, /*#__PURE__*/React.createElement(SearchLocations, {
          onSearchChange: _this2.onSearchChange,
          searchHeader: searchHeader,
          searchHeaderAs: searchHeaderAs,
          searchQuery: searchQuery,
          searchPlaceholder: searchPlaceholder,
          locationSortingStatus: geoClosestLocationStatus,
          onSort: _this2.onStartSortByDistance,
          distanceLoading: loading
        }))), /*#__PURE__*/React.createElement(Grid.Row, null, noResults && /*#__PURE__*/React.createElement("p", {
          style: {
            color: 'gray'
          }
        }, "No results found for the search", "\"".concat(searchQuery, "\".")), filteredLocations.map(function (loc) {
          return /*#__PURE__*/React.createElement(Grid.Column, {
            id: loc.id,
            computer: 8,
            tablet: 8,
            mobile: 16,
            className: "location-filter-location-detail"
          }, /*#__PURE__*/React.createElement(Location, _extends({
            address: {
              street: loc.street,
              city: loc.city,
              state: loc.state,
              zip: loc.zipCode,
              country: loc.country
            },
            timezone: loc.timezone,
            hours: loc.hours,
            phone: loc.phoneNumber,
            as: "card",
            showAddress: true,
            showIcon: showIcon,
            showMap: filteredLocations.length === 1
          }, loc)));
        })));
      }));
    }
  }]);
  return LocationsSorted;
}(React.Component);
export { LocationsSorted as default };
LocationsSorted.defaultProps = {
  className: '',
  distanceUnit: 'M',
  searchHeader: 'Search Our Locations',
  searchHeaderAs: 'h2',
  searchPlaceholder: '123 Main Street, Boston MA',
  verticalAlign: 'center',
  horizontalAlign: 'center',
  showIcon: true
};